import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import Button from './ui/button';
import NewsBanner from './NewsBanner';
import LetsTalk from './LetsTalk';

const NewsPage = () => {
  return (
    <>
      <SEO
        title="News – Lloyd James Media"
        description="Stay updated with the latest news, insights, and expert articles on data management, lead generation, marketing strategies, and business intelligence."
        keywords="data news, marketing insights, lead generation tips, data management articles, business intelligence, Lloyd James"
        canonical="/news"
      />
      <div>
      {/* Banner Section */}
      <NewsBanner />
      
      {/* News Articles Section */}
      <section className="py-16 sm:py-20 md:py-24" style={{ backgroundColor: '#3a3a3a' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
            
            {/* Article 1 - Lead Generation Campaign */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/home-banner-1.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  How to create a successful lead generation campaign
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  What is a lead generation campaign? A Lead generation campaign is the...
                </p>
                <Link
                  to="/how-to-create-a-successful-lead-generation-campaign"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  style={{
                    ':hover': {
                      color: '#db0058',
                      borderColor: '#db0058'
                    }
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 2 - Optimise your sales team's performance with good data management */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-10.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  Optimise your sales team's performance with good data management
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  Sales teams today have more data to process than ever before. With...
                </p>
                <Link
                  to="/data-management-sales-team"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 3 - What is lead generation, and what are the costs? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-7.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  What is lead generation, and what are the costs?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  Lead generation is essential for sustainable growth and is the first step…
                </p>
                <Link
                  to="/what-is-lead-generation-and-costs/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              
              </div>
            </div>

            {/* Article 4 - Where can I acquire customer data to build my business? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-9.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  Where can I acquire customer data to build my business?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  Customer data lists are essential to all industries who are looking to…
                </p>
                <Link
                  to="/customer-data-online/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 5 - The dos and don'ts of direct mail marketing campaigns */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-8.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  The dos and don'ts of direct mail marketing campaigns
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  Using direct mail marketing has a wide range of advantages and can…
                </p>
                <Link
                  to="/direct-mail-marketing-tips/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 6 - What are the most common data quality issues? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-5.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  What are the most common data quality issues?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  In today's data driven world, high quality data is key to success…
                </p>
                <Link
                  to="/most-common-data-issues/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 8 - A quick guide on data quality [why is it important?]*/}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/data-quality-why-is-it-important.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  A quick guide on data quality [why is it important?]
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  So, first things first. What is data quality? In it's simplest form…
                </p>
                <Link
                  to="/data-quality/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
  
            </div>
            {/* Article 9 - What does good data management look like?*/}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-2.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  What does good data management look like?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  In marketing, having a data management plan is crucial for all organisation…
                </p>
                <Link
                  to="/good-data-management/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 10 - The Rise of Wordle: What is it and how are brands joining the hype? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images-1.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  The Rise of Wordle: What is it and how are brands joining the hype?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  An online word game developed by Josh Wardle. Players attempt to guess…
                </p>
                <Link
                  to="/wordle-how-are-brands-joining-the-hype/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 11 - 5 helpful tips on buying new customers */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/LJM-Blog-Images.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  5 helpful tips on buying new customers
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  This year, one of your resolutions may have been to increase your…
                </p>
                <Link
                  to="/5-helpful-tips-on-buying-new-customers/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 12 - Telephone survey leads [how to use them in your strategy] */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/tele-survey-leads-for-sales-team.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  Telephone survey leads [how to use them in your strategy]
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  We're pleased to announce that telephone survey leads are back by popular…
                </p>
                <Link
                  to="/telephone-survey-leads/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 13 - Where to buy data for marketing? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/data-for-marketing-where-can-you-buy-it.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  Where to buy data for marketing?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  Data analytics in marketing helps to create segmented consumer lists and insights…
                </p>
                <Link
                  to="/data-for-marketing/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 14 - What does data cleansing mean? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/Lloyd-James-Data-Cleansing-.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  What does data cleansing mean?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  In today's blog, we will be talking all things data cleansing. Data…
                </p>
                <Link
                  to="/data-cleansing/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

            {/* Article 15 - What is lead generation in data marketing? */}
            <div className="relative flex flex-col h-full">
              {/* Article Image - Top Half */}
              <div className="h-64 sm:h-72 bg-cover bg-center rounded-t-lg" style={{ backgroundImage: "url('/images/Lloyd-James-Data-Marketing.webp')" }}>
              </div>
              
              {/* Article Content - Bottom Half in White Box */}
              <div className="bg-white p-6 sm:p-8 rounded-b-lg flex-1 flex flex-col">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 leading-tight">
                  What is lead generation in data marketing?
                </h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">
                  In marketing, the end goal of lead generation is to expand revenue.…
                </p>
                <Link
                  to="/lead-generation-marketing/"
                  className="text-black font-semibold text-sm border-b-2 border-black inline-block transition-colors duration-300"
                  onMouseEnter={(e) => {
                    e.target.style.color = '#db0058';
                    e.target.style.borderColor = '#db0058';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = 'black';
                    e.target.style.borderColor = 'black';
                  }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Read More
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Data Redefined Section */}
      <div className="w-full">
        <div className="flex flex-col md:flex-row h-auto md:h-96">
          <div className="w-full md:w-1/2 text-white p-8 md:p-12 flex flex-col justify-center" style={{ backgroundColor: 'rgb(172, 23, 64)' }}>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              Data, <span className="font-normal">redefined.</span>
            </h3>
            <p className="text-sm sm:text-base leading-relaxed mb-8">
              Data is only ever data, unless it's high quality, accurate and brought to life in the right way. We work closely with our customers to deliver meaningful insight that drives performance and growth with a service that's tailored to each and every business.
            </p>
            <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium">
                Find out more about our approach
              </Button>
            </Link>
          </div>
          <div className="w-full md:w-1/2 text-white p-8 md:p-12 flex flex-col justify-center" style={{ backgroundColor: 'rgb(151, 2, 99)' }}>
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              Unlock the power of <span className="font-normal">data.</span>
            </h3>
            <p className="text-sm sm:text-base leading-relaxed mb-8">
              With our market-leading data service, Resident, we're able to provide you with a single view of the UK covering 96% of all households and 52 million individuals. But it's not the volume of our data that's impressive — it's the accuracy and quality that sets it apart.
            </p>
            <Link to="/product" onClick={() => window.scrollTo(0, 0)}>
              <Button variant="primary" size="medium">
                Find out more about Resident
              </Button>
            </Link>
          </div>
        </div>
  
        {/* Let's Talk Section */}
        <LetsTalk />
      </div>
      </div>
    </>
  );
};

export default NewsPage;